"use client";

import { setCampaignPaymentCookie } from "@lib/analyticLog";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

/*
キャンペーン解析ログ用コンポーネント（エピソードページ用）
*/

export function EpisodePageLogger({ episodeId }: { episodeId: undefined | number }) {
  const query = useSearchParams();
  useEffect(() => {
    setCampaignPaymentCookie("article", episodeId, query);
  }, [query, episodeId]);
  return <></>;
}
